import { Header } from "../components/Header/index";
import { Hero } from "../components/Hero/index";
import { LoadingScreen } from "../components/LoadingScreen/index";
import { Subpage } from "../components/Subpage/index";
import "./style.css";

export const AppShell = () => (
  <>
    <LoadingScreen />
    <div className="ui-layer">
      <div className="ui-container">
        <Header />
        <Hero />
        <Subpage />
      </div>
    </div>
    <canvas className="webgl" />
  </>
);
